import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionTitle } from "@/components/SectionTitle";
import { ServiceCard } from "@/components/ServiceCard";
import { Link } from "react-router-dom";

export const ServicesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container-custom">
        <SectionTitle 
          subtitle="Our Services" 
          title="Top Dental Clinic in Sadar, Nagpur" 
          description="We offer a wide range of dental services to meet all your oral health needs, from routine check-ups to advanced cosmetic and restorative procedures at our dental clinic in Sadar, Nagpur." 
        />
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <ServiceCard 
            title="Full Mouth Rehabilitation" 
            description="Complete restoration of oral health and function with our comprehensive full mouth rehabilitation treatments for damaged or missing teeth." 
            link="/services/full-mouth-implants-in-nagpur"
            imageUrl="/lovable-uploads/6defff51-89fa-4b80-9681-9d58472908b7.png"
          />
          
          <ServiceCard 
            title="Dental Implants" 
            description="Replace missing teeth with state-of-the-art dental implants that look, feel, and function like natural teeth for a complete smile restoration." 
            link="/services/dental-implants-in-nagpur"
            imageUrl="/lovable-uploads/Implants.png"
          />
          
          <ServiceCard 
            title="Orthodontics" 
            description="Achieve a straighter smile with our range of orthodontic treatments including Invisalign clear aligners and traditional metal or ceramic braces." 
            link="/services/orthodontics-in-nagpur"
            imageUrl="/lovable-uploads/Orthodontics.png"
          />
          
          <ServiceCard 
            title="Painless Dentistry - RCT" 
            description="Advanced root canal treatments using the latest techniques and anesthesia to ensure a comfortable, pain-free experience." 
            link="/services/painless-rct-in-nagpur"
            imageUrl="/lovable-uploads/RCT.png"
          />
          
          <ServiceCard 
            title="Best Kids Dental Clinic in Nagpur Sadar" 
            description="Child-friendly dental care in a comfortable environment, establishing good oral health habits early. Our pediatric specialists create a fun, relaxing experience for children." 
            link="/services/pediatric-dentistry-in-nagpur"
            imageUrl="/lovable-uploads/Kids.png"
          />
          
          <ServiceCard 
            title="Cosmetic Dentistry" 
            description="Transform your smile with our range of cosmetic treatments including veneers, bonding, and professional teeth whitening for a brighter smile." 
            link="/services/cosmetic-dentistry"
            imageUrl="/lovable-uploads/Consmetic Dental.png"
          />
        </div>
        
        <div className="text-center mt-12">
          <Button className="btn-primary flex items-center text-base mx-auto group" asChild>
            <Link to="/services">
              View All Services
              <ArrowRight size={18} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>

        <div className="mt-16 bg-dental-offwhite/50 p-6 rounded-xl shadow-sm">
          <h2 className="text-2xl md:text-3xl font-serif font-semibold mb-4">Advanced & Affordable Dental Treatments</h2>
          <p className="text-dental-muted">
            At Asrani Dental, we're committed to providing high-quality dental care at reasonable prices. Our <Link to="/services/dental-implants-in-nagpur" className="text-dental-highlight hover:underline">Top Dental Clinic in Sadar Nagpur</Link> features state-of-the-art equipment and a team of specialists who stay updated with the latest advancements in dentistry. Whether you need a simple check-up or complex dental surgery, we ensure the highest standards of care and comfort.
          </p>
        </div>
        
        <div className="mt-12 bg-dental-offwhite/50 p-6 rounded-xl shadow-sm">
          <h2 className="text-2xl md:text-3xl font-serif font-semibold mb-4">Why Families Trust Asrani Dental in Nagpur</h2>
          <p className="text-dental-muted">
            With over 35 years of experience, Dr. Hemant Asrani has earned the reputation of being the best dentist in Nagpur. Families trust us for our gentle approach, transparent pricing, and excellent results. Our clinic in Sadar is easily accessible and equipped with modern amenities to make your dental visit comfortable and stress-free.
          </p>
        </div>
      </div>
    </section>
  );
};
